import React from "react";
import Newsletter_41 from "../component/Newsletter_41";

function Newsletter_41_Container() {
  return <Newsletter_41 />;
}

export default Newsletter_41_Container;
